/**
 * The dashboard banner's POLLED notifications - the ones raised from a refresh of the account
 * balance, which runs every 45 seconds while a dashboard tab is open (see AccountSummaryHeader).
 *
 * Their own module rather than store/index.js, which imports every store module and therefore
 * cannot be imported back from one of them.
 *
 * What makes them different from everything else in that one banner slot is that they are
 * REVISITED: the poll comes round, and whatever it finds is the truth. Everything else in the slot
 * - the minimum initial deposit prompt, a campaign's own daily budget - is raised once by something
 * that is not watching the account and would never put it back, so the poll must not take those
 * down. See `syncPolledDashboardNotification`.
 */
export const DASHBOARD_NOTIFICATION_KEYS = Object.freeze({
  BALANCE_LOW: 'balanceLow',
  DAILY_BUDGET_REACHED: 'dailyBudgetReached'
})

export const POLLED_DASHBOARD_NOTIFICATION_KEYS = Object.freeze(
  Object.values(DASHBOARD_NOTIFICATION_KEYS)
)

/**
 * Not dismissible, both of them - `hideOnClick: false` hides the banner's close button. Neither is
 * news the buyer can take in and move on from: the account cannot buy calls until somebody acts,
 * and a banner they can wave away is a banner they wave away once and then wonder why their
 * campaigns are silent.
 */
export const BALANCE_LOW_NOTIFICATION = Object.freeze({
  key: DASHBOARD_NOTIFICATION_KEYS.BALANCE_LOW,
  text: 'Your balance is too low to buy calls. ',
  linkText: 'Click here to add funds',
  routeName: 'AddFunds',
  hideOnClick: false
})

export const DAILY_BUDGET_REACHED_NOTIFICATION = Object.freeze({
  key: DASHBOARD_NOTIFICATION_KEYS.DAILY_BUDGET_REACHED,
  text: 'Your daily budget is exceeded. ',
  linkText: 'Click here to change account daily budget. ',
  routeName: 'BuyerAccountBudget',
  hideOnClick: false
})
